import React, {Component} from 'react';

class NotFoundPage extends Component {
  render() {
    return (
      <div>
        <h3 className='ta-center'>Resource not found!</h3>
      </div>
    );
  }
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/NotFoundPage.js